var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkpath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#68995D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 191.5,
    cy: 178.5,
    rx: 146.7,
    ry: 140.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M191.5,512c0,0,192-208,192-320c0-106-86-192-192-192s-192,86-192,192C-0.5,304,191.5,512,191.5,512z  M189.5,45.6c71.5,0,129.4,57.9,129.4,129.4S261,304.4,189.5,304.4S60.1,246.4,60.1,175S118.1,45.6,189.5,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M197.6,116.7c-27.6,0-51,18.1-59,43.1c11.8-6,25.1-9.3,39.3-9.3h30.9c3.1,0,5.6,2.5,5.6,5.6 c0,3.1-2.5,5.6-5.6,5.6h-5.6h-25.3l0,0c-5.8,0-11.5,0.7-17,1.9c-9.1,2.1-17.5,5.8-25.1,10.8l0,0C115.5,188,102,211.3,102,237.7v5.6 c0,4.7,3.8,8.4,8.4,8.4c4.7,0,8.4-3.8,8.4-8.4v-5.6c0-17.1,7.3-32.5,18.9-43.3c7,26.5,31.1,46.1,59.8,46.1h0.4 c46.4-0.2,84-46,84-102.4c0-15-2.6-29.2-7.4-42c-0.9-2.4-4.5-2.3-5.7,0c-6.6,12.4-19.7,20.8-34.7,20.8H197.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkpath);
export default __webpack_public_path__ + "static/media/parkpath.857a4eb2a6cd2fc89093c6de78400a31.svg";
export { ForwardRef as ReactComponent };